const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

// Simple cache to avoid refetching
const swatchProductCache = {};

function showOnlySlides(swiper, matchColorId) {
  swiper.slides.forEach(slide => {
    slide.style.display = slide.dataset.colorId === matchColorId ? "" : "none";
  });

  swiper.updateSlides();
  swiper.update();

  swiper.wrapperEl.style.transform = "translate3d(0,0,0)";

  swiper.slideTo(0, 120);
}


document.addEventListener("click", async function (e) {
  if (isTouchDevice) e.stopPropagation();
  const swatch = e.target.closest(".custom-color-swatch__link");
  if (!swatch) return;

  e.preventDefault();

  const productHandle = swatch.dataset.productHandle;
  const colorId = swatch.dataset.colorId;
  if (!productHandle) return;

  const productCard = swatch.closest("product-item");
  productCard.dataset.teaserDisabled = "true";
  const slider = productCard.querySelector(".product-item__image-slider");
  const swiper = slider?.swiper;
  if (!swiper) return;

  productCard.dataset.activeColor = colorId;

  productCard.querySelectorAll(".custom-color-swatch.active")
    .forEach(el => el.classList.remove("active"));

  swatch.closest(".custom-color-swatch").classList.add("active");

  let productData = swatchProductCache[productHandle];
  if (!productData) {
    try {
      const res = await fetch(`/products/${productHandle}.js`);
      if (!res.ok) throw new Error("Fetch failed");
      productData = await res.json();
      swatchProductCache[productHandle] = productData;
    } catch (err) {
      console.error("Fetch failed:", err);
      return;
    }
  }

  if (!productData?.images?.length) return;

  const removeIndexes = [];
  swiper.slides.forEach((slide, index) => {
    const slideColor = slide.dataset.colorId?.split("__")[1];
    const clickedColor = colorId.split("__")[1];

    if (slideColor === clickedColor && !slide.classList.contains("main-product")) {
      return;
    }

    if (
      !slide.classList.contains("main-product") &&
      !slide.classList.contains("preview-image") &&
      slide.dataset.colorId
    ) {
      removeIndexes.push(index);
  }
});

  if (removeIndexes.length) swiper.removeSlide(removeIndexes);

  swiper.slides.forEach(slide => {
    if (slide.classList.contains("main-product")) {
      slide.style.display = "none";
    }
  });

  productData.images.slice(1).forEach(image => {
    const newSlide = document.createElement("div");
    newSlide.className = "swiper-slide color-product-group";
    newSlide.dataset.colorId = colorId;
    
    const imageSize = "600";
    let productImage = image
    if (productImage.includes("width=")) {
      productImage = productImage.replace(/width=\d+/g, `width=${imageSize}`);
    }

    if (productImage.includes("?")) {
      productImage = `${productImage}&width=${imageSize}`;
    }

    newSlide.innerHTML = `
      <a href="/products/${productHandle}" class="product-item__slider-link">
        <img src="${productImage}" loading="eager" class="product-item__slider-image"/>
      </a>
    `;

    swiper.appendSlide(newSlide);
  });


  setTimeout(() => {
    swiper.updateSlides();
    swiper.update();
    swiper.slideTo(0, 250);
  }, 20);
});


document.addEventListener("mouseover", function (e) {
  if (isTouchDevice) return;
  const swatch = e.target.closest(".custom-color-swatch__link");
  if (!swatch) return;

  const colorId = swatch.dataset.colorId;
  const productCard = swatch.closest("product-item");
  const slider = productCard.querySelector(".product-item__image-slider");
  const swiper = slider?.swiper;
  if (!swiper) return;

  swiper.slides.forEach(slide => {
    const isPreview = slide.classList.contains("preview-image");
    slide.style.display =
      slide.dataset.colorId === colorId && isPreview ? "" : "none";
  });

  swiper.updateSlides();
  swiper.update();
  swiper.slideTo(0, 80);
});

document.addEventListener("mouseout", function (e) {
  if (isTouchDevice) return;
  const swatch = e.target.closest(".custom-color-swatch__link");
  if (!swatch) return;

  const productCard = swatch.closest("product-item");
  const slider = productCard.querySelector(".product-item__image-slider");
  const swiper = slider?.swiper;
  if (!swiper) return;

  const activeColor = productCard.dataset.activeColor;
  const activeColorSuffix = activeColor?.split("__")[1];

  swiper.slides.forEach(slide => {
    const slideColorSuffix = slide.dataset.colorId?.split("__")[1];

    if (!activeColor) {
      // No active selection → restore main product only
      slide.style.display = slide.classList.contains("main-product") ? "" : "none";
      return;
    }

    // Restore all preview & gallery slides for active color
    if (slideColorSuffix === activeColorSuffix) {
      slide.style.display = "";
    } else {
      slide.style.display = "none";
    }
  });

  swiper.updateSlides();
  swiper.update();
  swiper.slideTo(0, 120);
});




// async function triggerSwatchPreview(productCard, colorId) {
//     const slider = productCard.querySelector(".product-item__image-slider");
//     const swiperInstance = slider?.swiper;
//     if (!swiperInstance) return;

//     const swatch = productCard.querySelector(
//         `.custom-color-swatch__link[data-color-id="${colorId}"]`
//     );
//     if (!swatch) return;

//     const productHandle = swatch.dataset.productHandle;
//     if (!productHandle) return;

//     let productData = swatchProductCache[productHandle];

//     if (!productData) {
//         try {
//             const res = await fetch(`/products/${productHandle}.js`);
//             if (res.ok) {
//                 productData = await res.json();
//                 swatchProductCache[productHandle] = productData;
//             }
//         } catch (err) {
//             console.error("Hover fetch failed:", err);
//         }
//     }

//     if (!productData?.images?.length) return;

//     const removeIndexes = [];
//     Array.from(swiperInstance.slides).forEach((slide, i) => {
//         if (!slide.classList.contains("main-product")) removeIndexes.push(i);
//     });
//     if (removeIndexes.length) swiperInstance.removeSlide(removeIndexes);

//     swiperInstance.slides.forEach(slide => {
//         if (slide.classList.contains("main-product")) {
//             slide.style.display = "none";
//         }
//     });

//     productData.images.forEach(image => {
//         const newSlide = document.createElement("div");
//         newSlide.className = "swiper-slide color-product-group";
//         newSlide.dataset.colorId = colorId;

//         newSlide.innerHTML = `
//             <a href="/products/${productHandle}" class="product-item__slider-link">
//                 <img src="${image}" loading="lazy" class="product-item__slider-image" />
//             </a>
//         `;

//         swiperInstance.appendSlide(newSlide);
//     });

//     swiperInstance.updateSlides();
//     swiperInstance.update();

//     const firstMatch = Array.from(swiperInstance.slides)
//         .findIndex(slide => slide.dataset.colorId === colorId);

//     if (firstMatch >= 0) {
//         swiperInstance.slideTo(firstMatch, 200);
//     }
// }


// function resetToMainImages(productCard) {
//   const slider = productCard.querySelector(".product-item__image-slider");
//   const swiperInstance = slider?.swiper;
//   if (!swiperInstance) return;

//   swiperInstance.slides.forEach(slide => {
//     if (slide.classList.contains("main-product")) {
//       slide.style.display = "";
//     } else {
//       slide.style.display = "none";
//     }
//   });

//   swiperInstance.update();
//   swiperInstance.slideTo(0, 100);
// }


// document.addEventListener("mouseover", async function (e) {
//   const swatch = e.target.closest(".custom-color-swatch__link");
//   if (!swatch) return;

//   const productCard = swatch.closest("product-item");
//   if (!productCard) return;

//   const tempColor = swatch.dataset.colorId;

//   swatch.classList.add("hovering");

//   triggerSwatchPreview(productCard, tempColor);
// });

// document.addEventListener("mouseout", function (e) {
//   const swatch = e.target.closest(".custom-color-swatch__link");
//   if (!swatch) return;

//   swatch.classList.remove("hovering");

//   const productCard = swatch.closest("product-item");
//   if (!productCard) return;


//   const activeColor = productCard.dataset.activeColor;

//   if (activeColor) {
//     triggerSwatchPreview(productCard, activeColor);
//   } else {
//     resetToMainImages(productCard);
//   }
// });
